import type { ReactNode } from 'react';
import { alpha } from '@classify/react-core-components/styles';
import Button from '@classify/react-core-components/Button';

interface CategoryButtonProps {
  children: ReactNode;
  categoryColor: string | undefined;
}

const CategoryButton = ({
  children,
  categoryColor = 'initial',
  ...otherProps
}: CategoryButtonProps) => (
  <Button
    sx={{
      background: `${categoryColor} !important`,
      '&:hover': {
        background: `${alpha(categoryColor, 0.8)} !important`,
      },
    }}
    {...otherProps}
  >
    {children}
  </Button>
);

export default CategoryButton;
